import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import { Message } from "element-ui";

Vue.use(Router);
//重写路由的push方法
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/login", //重定向
    },
    {
      path: "/login",
      name: "login",
      component: () => import("../components/login.vue"),
    },
    {
      path: "/login_s",
      name: "login_s",
      component: () => import("../components/login_s.vue"),
    },
    {
      path: "/edit_home",
      name: "edit_home",
      component: () => import("../view/editCommunity/edit_home.vue"),
    },
    {
      path: "/contest",
      name: "contest",
      component: () => import("../view/editCommunity/contest.vue"),
    },
    {
      path: "/contest_details",
      name: "contest_details",
      component: () => import("../view/editCommunity/contest_details.vue"),
    },
    {
      path: "/detailed",
      name: "detailed",
      component: () => import("../view/editCommunity/detailed.vue"),
    },
    {
      path: "/app_sc",
      name: "app_sc",
      component: () => import("../view/editCommunity/app_sc.vue"),
    },
    {
      path: "/app_iphone",
      name: "app_iphone",
      component: () => import("../view/editCommunity/app_iphone.vue"),
    },
    {
      path: "/about",
      name: "about",
      component: () => import("../view/about.vue"),
    },
    {
      path: "/main",
      name: "main",
      component: () => import("../components/main.vue"),
      children: [
        {
          path: "/home",
          name: "home",
          component: () => import("../view/home.vue"),
        },
        {
          path: "/viewCourse",
          name: "viewCourse",
          component: () => import("../view/viewCourse.vue"),
        },
        {
          path: "/user",
          name: "user",
          component: () => import("../view/user.vue"),
        },
        {
          path: "/admin",
          name: "admin",
          component: () => import("../view/admin.vue"),
        },
        {
          path: "/addAccount",
          name: "addAccount",
          component: () => import("../view/addAccount.vue"),
        },
        {
          path: "/addChapter",
          name: "addChapter",
          component: () => import("../view/addChapter.vue"),
        },
        {
          path: "/addHandout",
          name: "addHandout",
          component: () => import("../view/addHandout.vue"),
        },
        {
          path: "/addPdf",
          name: "addPdf",
          component: () => import("../view/addPdf.vue"),
        },
        {
          path: "/addZip",
          name: "addZip",
          component: () => import("../view/addZip.vue"),
        },
        {
          path: "/courseDocuments",
          name: "courseDocuments",
          component: () => import("../view/courseDocuments.vue"),
        },
        {
          path: "/teacherAuthority",
          name: "teacherAuthority",
          component: () => import("../view/teacherAuthority.vue"),
        },
        {
          path: "/platform_viewCourse",
          name: "platform_viewCourse",
          component: () => import("../view/platform_viewCourse.vue"),
        },
        {
          path: "/platform_teacherAuthority",
          name: "platform_teacherAuthority",
          component: () => import("../view/platform_teacherAuthority.vue"),
        },
        {
          path: "/practice",
          name: "practice",
          component: () => import("../view/practice.vue"),
        },
        {
          path: "/platform_question_bank",
          name: "platform_question_bank",
          component: () => import("../view/platform_question_bank.vue"),
        },
        {
          path: "/campus_question_bank",
          name: "campus_question_bank",
          component: () => import("../view/campus_question_bank.vue"),
        },
        {
          path: "/official",
          name: "official",
          component: () => import("../view/official.vue"),
        },
        {
          path: "/practice",
          name: "practice",
          component: () => import("../view/practice.vue"),
        },
        {
          path: "/correction_topic",
          name: "correction_topic",
          component: () => import("../view/correction_topic.vue"),
        },
        {
          path: "/my_works",
          name: "my_works",
          component: () => import("../view/my_works.vue"),
        },
        {
          path: "/student_works",
          name: "student_works",
          component: () => import("../view/student_works.vue"),
        },
        {
          path: "/select_course",
          name: "select_course",
          component: () => import("../view/select_course.vue"),
        },
        {
          path: "/course_info",
          name: "course_info",
          component: () => import("../view/course_info.vue"),
        },
        {
          path: "/equipment",
          name: "equipment",
          component: () => import("../view/equipment.vue"),
        },
      ],
    },

    {
      path: "/404",
      name: "notFound",
      component: () => import("../components/404.vue"),
    },
    {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/404", //无匹配到的路径自动重定向到404页面
    },
  ],
});

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  //to 将要访问的路径
  // from 代表从哪个路径跳转而来
  // next 是一个函数， 表示放行
  // next（）放行    next('/login') 强制跳转
  if (to.path == "/login") {
    next();
  } else if (to.path == "/app_sc") {
    next();
  } else {
    next();
    let token = window.sessionStorage.getItem("token");
    if (token) {
      next();
    } else {
      next();
      // next("/login");
      // Message({
      //   message: "请登录账号！",
      //   type: "error",
      //   duration: 5 * 1000,
      // });
    }
  }
});

export default router;
